
// You can write more code here

/* START OF COMPILED CODE */

import UserComponent from "./UserComponent";
import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class FitTextToBounds extends UserComponent {

  constructor(gameObject: Phaser.GameObjects.Text | Phaser.GameObjects.BitmapText) {
    super(gameObject);

    this.gameObject = gameObject;
    (gameObject as any)["__FitTextToBounds"] = this;

    /* START-USER-CTR-CODE */
    this.gameObject.setData("textFitter",this);
    /* END-USER-CTR-CODE */
  }

  static getComponent(gameObject: Phaser.GameObjects.Text | Phaser.GameObjects.BitmapText): FitTextToBounds {
    return (gameObject as any)["__FitTextToBounds"];
  }

  private gameObject: Phaser.GameObjects.Text | Phaser.GameObjects.BitmapText;
  public MaxWidth: number = 0;
  public MaxHeight: number = 0;
  public MinFontSize: number = 0;
  public MultiLine: boolean = false;

  /* START-USER-CODE */
  private defaultFontSize : number = 10;
  private currentText:string = "";

  awake()
  {
    if (this.gameObject instanceof Phaser.GameObjects.Text) this.defaultFontSize = this.gameObject.getTextMetrics().fontSize;
    else if (this.gameObject instanceof Phaser.GameObjects.BitmapText) this.defaultFontSize = this.gameObject.fontSize;
    this.sizeText();
  }

  update(time: number, delta: number) {

    if(this.currentText!=this.gameObject.text){

      this.sizeText();
    }
  }

  public sizeText(){

    this.currentText = this.gameObject.text;
    this.gameObject.setFontSize(this.defaultFontSize);
    var fontSize:number = this.defaultFontSize;
    if(!this.MultiLine){

      while(this.gameObject.width>this.MaxWidth){
        fontSize = fontSize - 1;
        if(fontSize<this.MinFontSize){
          break;
        }
        this.gameObject.setFontSize(fontSize);

      }

    }
    else {

      while(this.gameObject.height>this.MaxHeight){
        fontSize = fontSize - 1;
        if(fontSize<this.MinFontSize){
          break;
        }
        this.gameObject.setFontSize(fontSize);

      }
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
